import { multi, withDependencies } from '@wix/thunderbolt-ioc'
import { FilesChangedMiddlewareSymbol } from './symbols'
import type { FileChangedMiddleware, IViewerManagerVeloApi } from './types'

export const ViewerManagerVeloApi = withDependencies(
	[multi(FilesChangedMiddlewareSymbol)],
	(filesChangedMiddlewares: Array<FileChangedMiddleware>): { velo: IViewerManagerVeloApi } => {
		return {
			velo: {
				refreshFilesOrFolders(filesDescriptors) {
					filesDescriptors.forEach((fileDescriptor) => {
						filesChangedMiddlewares.forEach(({ onFileChanged }) => onFileChanged(fileDescriptor))
					})
				},
			},
		}
	}
)
